// extracted by mini-css-extract-plugin
module.exports =  {"settings-container":"settings-container-_g1tS","settings-content":"settings-content-co5eU","sections-container":"sections-container-ZaZpD"};